var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#7B8CC8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 11.9803C9.2 12.247 8.8 12.247 8.6 11.9803L5.6 7.98034C5.35279 7.65072 5.58798 7.18034 6 7.18034L12 7.18034C12.412 7.18034 12.6472 7.65072 12.4 7.98034L9.4 11.9803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDecrease);
export default __webpack_public_path__ + "static/media/arrow-decrease.c9adfb9c84816f8149189f439ce5b723.svg";
export { ForwardRef as ReactComponent };